export const paramReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET':
      localStorage.setItem('params', JSON.stringify(payload));
      return payload;
    case 'GET':
      return JSON.parse(localStorage.getItem('params'));
    default:
      return state;
  }
};
